import { useMemo, useState } from 'react';

export default function useSortable(itens, campoInicial, direcaoInicial = 'asc') {
  const [campo, setCampo] = useState(campoInicial);
  const [direcao, setDirecao] = useState(direcaoInicial);

  const sorted = useMemo(() => {
    if (!campo) return itens;
    return [...itens].sort((a, b) => {
      const va = a[campo];
      const vb = b[campo];
      if (va == null) return 1;
      if (vb == null) return -1;
      if (va < vb) return direcao === 'asc' ? -1 : 1;
      if (va > vb) return direcao === 'asc' ? 1 : -1;
      return 0;
    });
  }, [itens, campo, direcao]);

  const ordenarPor = (novoCampo) => {
    if (novoCampo === campo) {
      setDirecao((d) => (d === 'asc' ? 'desc' : 'asc'));
    } else {
      setCampo(novoCampo);
      setDirecao('asc');
    }
  };

  const Th = ({ campo: campoTh, children }) => (
    <th role="button" onClick={() => ordenarPor(campoTh)} className="user-select-none">
      {children} {campo === campoTh && <i className={`bi bi-caret-${direcao === 'asc' ? 'up' : 'down'}-fill`} />}
    </th>
  );

  return { sorted, Th, ordenarPor };
}
